<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
    
      <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h1 i18n>Listx is a preloved marketplace that removes the effort from reselling your unused things</h1>
        <p i18n>Our smart Artificial Intelligence (AI) makes it possible to list anything for sale with just a few clicks. Furthermore, we have made it entirely free of charge to ensure as many items as possible return to circulation..</p>
        <div class="button-panel" style="margin-bottom: 64px">        
          <button 
              mat-raised-button
              routerLink="/select-listing-flow"
              angulartics2On="click" angularticsAction="SignUpClick"
              color="accent"
              i18n>START SELLING NOW</button>
        </div>
        
        <h1 i18n>Reselling made effortless</h1>
      </div>
      
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <a routerLink="/snap-and-sell"
            angulartics2On="click" 
            angularticsAction="Image Pressed"
            angularticsCategory="Snap&Sell">
          <img class="tile-img" [src]="'/learn_more_1.png' | assetUrl"/>
        </a>
        <h2>
          <a routerLink="/snap-and-sell"
              angularticsAction="Link Pressed"
              angularticsCategory="Snap&Sell"
              angularticsLabel="Snap&Sell"
              i18n>
            Snap&Sell
          </a>
        </h2>
        <p i18n>
          Just take a few pictures of the item you want to sell with our
          <a routerLink="/snap-and-sell" angulartics2On="click" angularticsAction="SnapAndSellLinkClick">Snap&Sell</a>
          feature and let our platform do the rest.
        </p>
      </div>
      
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <a routerLink="/access-inbox"
            angulartics2On="click" 
            angularticsAction="Image Pressed"
            angularticsCategory="Import purchases">
          <img class="tile-img" [src]="'/learn_more_2.png' | assetUrl"/>
        </a>
        <h2>
          <a routerLink="/access-inbox" 
              angulartics2On="click" 
              angularticsAction="Link Pressed"
              angularticsCategory="Import purchases"
              angularticsLabel="Import purchases"
              i18n>
            Import purchases
          </a>
        </h2>
        <p i18n>
          Resell any of your past online purchases by simply
          <a routerLink="/access-inbox" angulartics2On="click" angularticsAction="AccessInboxLinkClick">importing your purchase history</a>
          and creating the listing automatically with a few clicks.
        </p>
      </div>
      
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <a routerLink="/items-to-sell"
            angulartics2On="click" 
            angularticsAction="Image Pressed"
            angularticsCategory="Sell without listing"
            >
          <img class="tile-img" [src]="'/learn_more_3.png' | assetUrl"/>
        </a>
        <h2>
          <a routerLink="/items-to-sell"
              angulartics2On="click" 
              angularticsAction="Link Pressed"
              angularticsCategory="Sell without listing"
              angularticsLabel="Sell without listing"
              i18n>
            Sell without listing
          </a>
        </h2>
        <p i18n>
          Make all of
          <a routerLink="/items-to-sell" angulartics2On="click" angularticsAction="ItemsToSellLinkClick">your things</a>
          anonymously visible to other users and be ready to receive offers also for things that you are not actively selling (coming soon).
        </p>
      </div>
      
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <img class="tile-img" [src]="'/learn_more_4.png' | assetUrl"/>
        <h2 i18n>0% fees</h2>
        <p i18n>All transactions done on our platform are completely free of charge. 0% listing and transaction fees.</p>
      </div>
      
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <img class="tile-img" [src]="'/learn_more_5.png' | assetUrl"/>
        <h2 i18n>Communicate via chat</h2>
        <p i18n>Agree all transaction details (price, shipping, payment) via our built-in chat feature.</p>
      </div>
      
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <img class="tile-img" [src]="'/learn_more_6.png' | assetUrl"/>
        <h2 i18n>Complete the transaction</h2>
        <p i18n>Follow the transaction details agreed with the buyer. Once you have completed a successful sale, find more unused things to give new life to.</p>
      </div>
      
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h1 i18n>Buying on Listx</h1>
        <p i18n>Once you’ve found what you’re looking for at our marketplace, start a conversation with the seller via our built-in chat functionality. Use it to ask additional questions about the item and to agree the payment and shipping details.</p>
      </div>
      
    </div>
  </div>
</div>